import { PagingParameters } from "@/api/dtos";
import { CustomerRecap, useGetCustomers } from "@/api/order";
import { Badge } from "@/components/ui/badge";
import { DataTable } from "@/components/ui/datatable";
import { DatatablePagination } from "@/components/ui/datatable-pagination";
import { generateSortableHeader } from "@/components/ui/shared";
import { ColumnDef, Row, SortingState } from "@tanstack/react-table";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const columns: ColumnDef<CustomerRecap>[] = [
  {
    id: "customerEmail",
    size: 10000,
    header: generateSortableHeader("Client"),
    cell: ({ row }) => (
      <>
        <span>{row.original.email.toString()}</span>
      </>
    ),
  },
  {
    id: "_count.id",
    size: 1,
    header: generateSortableHeader("Nombres d'achats"),
    cell: ({ row }) => (
      <div className="flex flex-row justify-center">
        <Badge variant={"outlined"}>{row.original.orderCount.toString()}</Badge>
      </div>
    ),
  },
];

export const CustomerList = ({ search }: { search?: string }) => {
  const [getPagination, setPagination] = useState<PagingParameters>({
    page: 0,
    pageSize: 20,
  });

  const navigate = useNavigate();

  const [sorting, setSorting] = useState<SortingState>([]);

  const { data } = useGetCustomers(getPagination, sorting, search);

  const onRowClick = (row: Row<CustomerRecap>) => {
    navigate(`/e-shop/customer/${row.original.email}`);
  };

  return (
    <>
      <DataTable
        columns={columns}
        data={data?.data ?? []}
        onRowClick={onRowClick}
        options={{
          state: { sorting: sorting },
          onSortingChange: setSorting,
        }}
      ></DataTable>
      <DatatablePagination
        pagination={getPagination}
        setPage={setPagination}
        totalSize={data?.totalSize ?? 0}
      />
    </>
  );
};
